<template>
    <span v-if="!center">
      <i :class="['fad fa-spinner-third fa-spin', adClass]"></i>
    </span>
</template>

<script>
  export default {
    name: "Loading",
    props: {
      adClass: {
        default: '',
        type: String
      },
      center: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>

</style>
